import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import projects from '../data/projects';
import frame1 from '../Assets/Work_Images/1.png';
import frame2 from '../Assets/Work_Images/2.png';
import frame3 from '../Assets/Work_Images/3.png';
import frame4 from '../Assets/Work_Images/4.png';
import frame5 from '../Assets/Work_Images/5.png';
import frame6 from '../Assets/Work_Images/6.png';
import shop7 from '../Assets/Work_Images/7.png';
import shop8 from '../Assets/Work_Images/8.png';
import shop9 from '../Assets/Work_Images/9.png';
import shop10 from '../Assets/Work_Images/10.png';
import work1 from '../Assets/Work_Images/work1.jpg';
import work2 from '../Assets/Work_Images/work2.jpg';
import work3 from '../Assets/Work_Images/work3.jpg';
import work4 from '../Assets/Work_Images/work4.jpg';
import work5 from '../Assets/Work_Images/work5.jpg';
import work6 from '../Assets/Work_Images/work6.jpg';
import work7 from '../Assets/Work_Images/work7.jpg';

const filters = [
    { id: 'all', label: 'All Photos' },
    { id: 'glazing', label: 'Glazing & Facades' },
    { id: 'cladding', label: 'Cladding Works' },
    { id: 'doors', label: 'Doors & Windows' },
    { id: 'railing', label: 'Railing Systems' },
    { id: 'facility', label: 'Facility & Works' },
];

const categoryByProject = {
    1: 'glazing',
    2: 'glazing',
    3: 'cladding',
    4: 'doors',
    5: 'facility',
    6: 'railing',
    7: 'cladding',
    8: 'cladding',
    9: 'glazing',
    10: 'doors',
    11: 'glazing',
    12: 'glazing',
    13: 'glazing',
    14: 'facility',
};

const imageUrl = (photo) => (photo.bundled ? photo.src : `${process.env.PUBLIC_URL}${photo.src}`);

const earlierPhotos = [
    { id: 'earlier-1', src: frame1, title: 'Window and door frames', category: 'doors', bundled: true },
    { id: 'earlier-2', src: frame2, title: 'Window and door frames', category: 'doors', bundled: true },
    { id: 'earlier-3', src: frame3, title: 'Ventilator', category: 'doors', bundled: true },
    { id: 'earlier-4', src: frame4, title: 'Window frames', category: 'doors', bundled: true },
    { id: 'earlier-5', src: frame5, title: 'Window frames', category: 'doors', bundled: true },
    { id: 'earlier-6', src: frame6, title: 'Casement window', category: 'doors', bundled: true },
    { id: 'earlier-7', src: shop7, title: 'Fabrication workshop', category: 'facility', bundled: true },
    { id: 'earlier-8', src: shop8, title: 'Mullion end milling', category: 'facility', bundled: true },
    { id: 'earlier-9', src: shop9, title: 'Fabrication workshop', category: 'facility', bundled: true },
    { id: 'earlier-10', src: shop10, title: 'Fabrication workshop', category: 'facility', bundled: true },
    { id: 'earlier-work1', src: work1, title: 'Glazed sliding doors', category: 'doors', bundled: true },
    { id: 'earlier-work2', src: work2, title: 'Interior ceiling', category: 'facility', bundled: true },
    { id: 'earlier-work3', src: work3, title: 'Windows', category: 'doors', bundled: true },
    { id: 'earlier-work4', src: work4, title: 'Glass flooring', category: 'glazing', bundled: true },
    { id: 'earlier-work5', src: work5, title: 'Fabricated panels', category: 'cladding', bundled: true },
    { id: 'earlier-work6', src: work6, title: 'Glazed facade', category: 'glazing', bundled: true },
    { id: 'earlier-work7', src: work7, title: 'Cladding and glass railing', category: 'cladding', bundled: true },
];

const photos = [
    ...projects.flatMap((project) => project.images.map((src, index) => ({
        id: `${project.id}-${index}`,
        src,
        title: project.title,
        location: project.location,
        category: categoryByProject[project.id],
    }))),
    ...earlierPhotos,
];

const GallerySection = () => {
    const [filter, setFilter] = useState('all');
    const [active, setActive] = useState(null);
    const visible = filter === 'all' ? photos : photos.filter((photo) => photo.category === filter);

    useEffect(() => {
        if (!active) return undefined;
        const onKey = (event) => {
            if (event.key === 'Escape') setActive(null);
            if (event.key === 'ArrowRight') step(1);
            if (event.key === 'ArrowLeft') step(-1);
        };
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = previous;
            window.removeEventListener('keydown', onKey);
        };
    }, [active, visible]);

    const step = (delta) => {
        const index = visible.findIndex((photo) => photo.id === active?.id);
        if (index < 0) return;
        setActive(visible[(index + delta + visible.length) % visible.length]);
    };

    const lightbox = active ? createPortal(
        <div className="gallery-lightbox" role="dialog" aria-modal="true" aria-label={active.title} onClick={() => setActive(null)}>
            <div className="gallery-lightbox-dialog" onClick={(event) => event.stopPropagation()}>
                <button type="button" className="gallery-lightbox-close" aria-label="Close" onClick={() => setActive(null)}>×</button>
                <button type="button" className="gallery-lightbox-nav is-prev" aria-label="Previous image" onClick={() => step(-1)}>‹</button>
                <figure>
                    <img src={imageUrl(active)} alt={active.location ? `${active.title}, ${active.location}` : active.title} />
                    <figcaption>
                        {active.title}{active.location ? ` — ${active.location}` : ''}
                    </figcaption>
                </figure>
                <button type="button" className="gallery-lightbox-nav is-next" aria-label="Next image" onClick={() => step(1)}>›</button>
            </div>
        </div>,
        document.body,
    ) : null;

    return (
        <section className="page-section gallery-section" id="gallery">
            <div className="container">
                <div className="section-intro reveal">
                    <p className="eyebrow">On site</p>
                    <h2 className="section-title">Our gallery</h2>
                    <p>Project photographs, grouped by the work on each site.</p>
                </div>
                <div className="gallery-filters" role="tablist" aria-label="Work type">
                    {filters.map((item) => {
                        const count = item.id === 'all'
                            ? photos.length
                            : photos.filter((photo) => photo.category === item.id).length;
                        return (
                            <button
                                key={item.id}
                                type="button"
                                role="tab"
                                aria-selected={filter === item.id}
                                className={`project-filter ${filter === item.id ? 'is-active' : ''}`}
                                onClick={() => setFilter(item.id)}
                            >
                                {item.label}
                                <span>({count})</span>
                            </button>
                        );
                    })}
                </div>
                <div className="row g-4">
                    {visible.map((photo, index) => (
                        <div key={photo.id} className="col-6 col-md-4 col-lg-3">
                            <button
                                type="button"
                                className="gallery-tile reveal"
                                style={{ transitionDelay: `${(index % 4) * 80}ms` }}
                                onClick={() => setActive(photo)}
                            >
                                <img src={imageUrl(photo)} alt={photo.location ? `${photo.title}, ${photo.location}` : photo.title} />
                                <span className="gallery-caption">
                                    <strong>{photo.title}</strong>
                                    <em>{filters.find((item) => item.id === photo.category)?.label}</em>
                                </span>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            {lightbox}
        </section>
    );
};

export default GallerySection;
